module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA8UExURf+eKf+AD/+RIf+ADv+PIf6QH/+iLf+CEUdwTP+RHP+hLf+SHv94CP+qNf+aJv+RHv+jLv9/Dv+KGP+FFAs3fCYAAAAOdFJOUybJNHcSHckmAAl48vLyErhQnAAAAH9JREFUeNpt0VkOgCAMBNBBC1j35f53lakhTUzhy5e2wIjJlkoGsuj3BaMmqFxZO0qjrlWINEcqUU3msixpNNWGnDeUfT+O+0kD506wwnJ+eCUrhbD37HhxgiCz0JGlJGBzXNkfYtgeHhReKbp8+EwPpNrugfxiEg+Z5iGHv+MFm4sLsprHV48AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon@2x(4).png
// module id = 4P2m
// module chunks = 1